import React, { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";


export type ContentDividerPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  contentDividerStyle?: "singleLine" | "dualLine" | "backgroundFill"
  contentDividerType?: "heading" | "text" | "element"
}

export const ContentDivider = memo(forwardRef<HTMLDivElement, ContentDividerPropsType>((
  {
    contentDividerStyle = "singleLine", 
    contentDividerType = "text",
    children,
    className,
    ...props
  }, ref) => {

  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[contentDividerStyle as keyof typeof styles],
        styles[contentDividerType as keyof typeof styles],
        {
          [styles.noContent]: !children
        }
      )}
    >
      <div className={styles.content}>{children}</div>
    </div>
  );
}));
